import { getAudioGraph } from './get-audio-graph';
import { getValueForKey } from './get-value-for-key';
export const getAudioNodeConnections = (audioNode) => {
    const audioGraph = getAudioGraph(audioNode.context);
    return getValueForKey(audioGraph.nodes, audioNode);
};
//# sourceMappingURL=/build/es2018/helpers/get-audio-node-connections.js.map